import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FeaturesModule } from './features/features.module';
import { DataTablesModule } from 'angular-datatables';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthService } from './core/auth/auth.service';
import { environment } from '@env/environment';
import { TimeOutInterceptor } from './shared/interceptor/timeOut.interceptor';
import { ConfirmationService } from './core/confirmation/confirmation.service';
import { ErrorService } from './core/error/error.service';

import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FeaturesModule,
    DataTablesModule,
    RouterModule,
    // ************************************************************
    // inyectar el servicio de internacionalización
    // ************************************************************
    TranslateModule.forRoot({
      // se devine el cargador
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
        deps: [
          HttpClient
        ]
      }
    }),
    // ************************************************************
    // inyectar el servicio de carga de token automática en las peticiones HTTP
    // ************************************************************
    JwtModule.forRoot({
      config: {
        // se define el metodo que captura el token, es uno estático del servicio de Auth
        tokenGetter: jwtTokenGetter
        // se define la lista de dominios permitidos, las coge de
        // la configuración del entorno
        //allowedDomains: environment.availableDomains
      }
    })
  ],
    // ************************************************************
    // inyectar el servicio de carga de token automática en las peticiones HTTP
    // segunda forma de hacerla
    // ************************************************************
    providers: [
      ConfirmationService,
      ErrorService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      { 
        provide: HTTP_INTERCEPTORS, 
        useClass: TimeOutInterceptor, 
        multi: true },
      // Configura el LOCALE_ID al valor establecido en el navegador
      // Afecta a la ejeución de los siguientes pipes: DatePipe, I18nPluralPipe, 
      // CurrencyPipe, DecimalPipe and PercentPipe
      {
        provide: LOCALE_ID,
        useValue: navigator.language,
      }
  ],
  // entryComponents: [ ConfirmationComponent, ErrorComponent ],
  bootstrap: [AppComponent]
})

export class AppModule { }

// función para la capturar la petición de token
// const jwtTokenGetter = (): string => AuthService.getToken();
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function jwtTokenGetter(): string {
  return AuthService.getToken();
}
